export const GENERATION_JOB_SESSION_KEY = "tema_generation_job_ids";

export const GENERATION_JOB_POLL_INTERVAL_MS = 3000;

export const TERMINAL_GENERATION_JOB_STATUSES = new Set([
  "completed",
  "failed",
  "cancelled",
  "expired",
]);

export const GENERATION_JOB_STATUS_LABELS = {
  queued: "Queued",
  processing: "In Progress",
  completed: "Completed",
  failed: "Failed",
  cancelled: "Cancelled",
  expired: "Expired",
};

export function isGenerationJobTerminal(status) {
  return TERMINAL_GENERATION_JOB_STATUSES.has(status);
}

export function getGenerationJobStatusLabel(status) {
  return GENERATION_JOB_STATUS_LABELS[status] ?? status;
}

export function readGenerationJobsEnabled() {
  if (typeof process === "undefined" || !process.env) {
    return true;
  }
  return process.env.REACT_APP_GENERATION_JOBS_ENABLED !== "false";
}
